// ─── accountApi ──────────────────────────────────────────────────────────────
// Account-scoped calls that aren't tied to a project.
//
//   POST /api/account/verify-password/   re-authenticate the signed-in user
//
// URL + token conventions follow widgetConfigStore.js / messageAdminApi.js.

import axios from 'axios'

const API_URL         = import.meta.env.VITE_API_URL         || ''
const API_BASE_PATH   = import.meta.env.VITE_API_BASE_PATH   || '/api'
const JWT_STORAGE_KEY = import.meta.env.VITE_JWT_STORAGE_KEY || 'auth_token'

const getToken = () =>
  localStorage.getItem(JWT_STORAGE_KEY) || sessionStorage.getItem(JWT_STORAGE_KEY) || ''

/**
 * Re-check the signed-in user's own password (the Edit Mode "Admin Sign In"
 * prompt). Resolves on success; throws an Error whose message is safe to show
 * — the server deliberately returns the same wording for a bad email and a
 * bad password, and a distinct one when the attempt limit is hit.
 *
 * The password is passed straight through and never persisted here.
 */
export async function verifyPassword({ email, password }) {
  const token = getToken()
  try {
    const res = await axios.post(
      `${API_URL}${API_BASE_PATH}/account/verify-password/`,
      { email, password },
      {
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      },
    )
    return res.data
  } catch (err) {
    throw new Error(
      err?.response?.data?.error ||
      'Could not verify your password. Please try again.',
    )
  }
}
